export interface CountryItem {
  id: number;
  code: string;
  name: string;
  dialCode: string | null;
  isActive: boolean;
  sortOrder: number;
  allowedCurrencies: string[];
  tagIds: number[];
  userCount: number;
  createdAt: string;
  updatedAt: string;
}

// ISO-3166-1 alpha-2 → Regional Indicator Symbols → emoji-флаг
// "UZ" → 🇺🇿. Чисто client-side, не хранится в БД.
export function codeToFlagEmoji(code: string | null | undefined): string {
  if (!code || code.length !== 2) return '🏳️';
  const upper = code.toUpperCase();
  const A = 0x1F1E6;
  const ACode = 'A'.charCodeAt(0);
  const first = upper.charCodeAt(0) - ACode;
  const second = upper.charCodeAt(1) - ACode;
  if (first < 0 || first > 25 || second < 0 || second > 25) return '🏳️';
  return String.fromCodePoint(A + first, A + second);
}
